import fluidvids from "fluidvids.js";

export default class ResponsiveVideos {
  static init() {
    fluidvids.init({
      selector: ["iframe", "object"],
      players: [
        "c15119308.ssl.cf2.rackcdn.com",
        "youtube.com",
        "www.youtube.com",
        "player.vimeo.com",
        "maps.google.com",
        "youtube-nocookie.com",
      ],
    });
  }
}
